import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Api from "../../Api";
import { ListPageUrlCategory, NewPageUrlCategoryModalForm } from "../../component";

const PageUrlCategory = () => {
  interface PageUrlCategory {
    categoryId: number;
    categoryName: string;
  }
  
  const initialState = {
    categoryName: null,
  };

  const [PageUrlCategories, setPageUrlCategories] = useState<PageUrlCategory[]>([
  ]);
  const [findOptions, setFindOptions] = useState(initialState);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [listCount, setListCount] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState({categoryId: 0, categoryName: ""});
  const [isEdit, setIsEdit] = useState(false);
  const resetFindOptions = () => setFindOptions(initialState);
  const api = Api();

  const handleFind = (findOptions: any) => setFindOptions(findOptions);
  const onCreateOrUpdatePageUrlCategory = (payload: {"categoryName": string}) => {
    if(isEdit){
      api.pageUrlCategory.updatePageURLCategory(payload).then((response: any) => {
        toast.success(response.message);
        getPageUrlCategories({...findOptions, pageIndex, pageSize});
      });
    }else{
      api.pageUrlCategory.createPageURLCategory(payload).then((response: any) => {
        toast.success(response.message);
        getPageUrlCategories({...findOptions, pageIndex, pageSize});
      });
    }
  };

  const getPageUrlCategories = (findOptions: any) => {
    api.pageUrlCategory.searchPageURLCategory(findOptions).then((response: any)=>{
      if(response){
        setListCount(response.pageURLCategoryListCount);
        setPageUrlCategories(response.pageURLCategoryList)
        if(response.pageURLCategoryListPageIndex>1 && response.pageURLCategoryListPageSize === 0){
          setPageIndex(pageIndex-1)
        }
      }
    })
  };

  const handelDelete = (categoryId: number) => {
    api.pageUrlCategory.deletePageURLCategory(categoryId).then((response: any)=>{
      if(response){
        toast.success(response.message);
        getPageUrlCategories({...findOptions, pageIndex, pageSize});
      }
    })
  };

  const onChangePageIndex = (pageNumber: number) =>
    setPageIndex(pageNumber - 1);
  const onChangePageSize = (pageSize: number) => setPageSize(pageSize);
  
    const PageUrlCategoryValidationSchema = Yup.object().shape({
        categoryName: Yup.string().required("Category Name is required"),
      });

  useEffect(() => {
    getPageUrlCategories({ ...findOptions, pageIndex, pageSize });
  }, [findOptions, pageIndex, pageSize]);

  const onCloseHandler=()=>{
    setIsEdit(false)
  }

  const editHandler = (category: any)=>{
    setSelectedRecord({
      categoryId: category.categoryId,
      categoryName: category.categoryName,
    });
    setIsEdit(true)
  }


  return (
    <div className="w-100">
      <div className="float-end mx-2">
        <NewPageUrlCategoryModalForm
          onCreateNewPageUrlCategory={onCreateOrUpdatePageUrlCategory}
          PageUrlCategoryValidationSchema={PageUrlCategoryValidationSchema}
          pageUrlCategoryData={selectedRecord}
          isEdit={isEdit}
          onClose={()=>onCloseHandler()}
        />
      </div>

      <ListPageUrlCategory
        pageUrlCategoryList={PageUrlCategories}
        resetFindOptions={resetFindOptions}
        findOptions={findOptions}
        handleFind={handleFind}
        handelDelete={( categoryId: number) =>
          handelDelete(categoryId)
        }
        handelEdit={(state)=>editHandler(state)}
        totalItemCount={listCount}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onChangePageIndex={(pageNumber: number) =>
          onChangePageIndex(pageNumber)
        }
        onChangePageSize={onChangePageSize}
      />
    </div>
  );
};

export default PageUrlCategory;
